export default "__VITE_ASSET__BcBztbo0__"